// NPM Imports
import { get, getForFileAsResponse, post } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";

// Destructuring
const { APIS } = API_ENDPOINTS;

export const getSigningPdfFile = (docID, signingHash) =>
  new Promise((resolve, reject) => {
    getForFileAsResponse(
      `${APIS.SIGNING_DOCUMENTS}/${docID}/${signingHash}/pdf`,
      "blob",
    )
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const getSigningDetails = (docID, signingHash) =>
  new Promise((resolve, reject) => {
    get(`${APIS.SIGNING_DOCUMENTS}/${docID}/${signingHash}/info`)
      .then(res => {
        resolve(res.Info);
      })
      .catch(err => {
        reject(err);
      });
  });

export const sendDocForSigningService = (docID, signingHash, payload, view) =>
  new Promise((resolve, reject) => {
    post(
      `${APIS.SIGNING_DOCUMENTS}/${docID}/${signingHash}/signing/${view}`,
      payload,
    )
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const getSignedDocumentService = (docID, signingHash) =>
  new Promise((resolve, reject) => {
    getForFileAsResponse(
      `${APIS.SIGNING_DOCUMENTS}/${docID}/${signingHash}/signed-pdf`,
    )
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const getEvidenceSummaryService = (docID, sharingHash, shared, isLz) =>
  new Promise((resolve, reject) => {
    let url = `${APIS.SIGNING_DOCUMENTS_LZ}/${docID}/${sharingHash}/evidence`;
    if (shared) {
      url = isLz
        ? `${APIS.SHARED_DOCUMENTS_LZ}/${docID}/${sharingHash}/evidence`
        : `${APIS.SHARED_DOCUMENTS_RV}/${docID}/${sharingHash}/evidence`;
    } else {
      url = isLz
        ? `${APIS.SIGNING_DOCUMENTS_LZ}/${docID}/${sharingHash}/evidence`
        : `${APIS.SIGNING_DOCUMENTS_RV}/${docID}/${sharingHash}/evidence`;
    }
    getForFileAsResponse(`${url}`)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const requestExpiryEntension = (docID, signingHash) =>
  new Promise((resolve, reject) => {
    post(
      `${APIS.SIGNING_DOCUMENTS}/${docID}/${signingHash}/expiry-extension-request`,
    )
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const requestExpiryEntensionLZ = (objectId, signingHash) =>
  new Promise((resolve, reject) => {
    post(
      `${APIS.SIGNING_DOCUMENTS}/${objectId}/${signingHash}/expiry-extension-request`,
    )
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
